import { render, staticRenderFns } from "./EditCalendarCategories.vue?vue&type=template&id=43a6d8f1&"
import script from "./EditCalendarCategories.vue?vue&type=script&lang=js&"
export * from "./EditCalendarCategories.vue?vue&type=script&lang=js&"
import style0 from "./EditCalendarCategories.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports